import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GEO_ID, PRICE_ID } from '../../../../constants/nodeIds';
import { useIsMobileDevice, useScrollTo } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { closeAuction, ETopBetsErrorCode, reloadBetPosition, reloadTopBets } from '../../../../redux/reducers';
import { selectNeedBetPositionReload } from '../../../../selectors/betPosition';
import { selectNeedBetLeadersReload, selectTopBetsErrorCode } from '../../../../selectors/topBets';
import { GeoEmptyError } from './components/GeoEmptyError';
import { PriceAndGeoEmptyError } from './components/PriceAndGeoEmptyError';
import { PriceEmptyError } from './components/PriceEmptyError';
import { ServiceNotSupportedError } from './components/ServiceNotSupportedError';
import { UnexpectedError } from './components/UnexpectedError';

export const BetLeadersErrorContainer = () => {
  const isMobile = useIsMobileDevice();
  const scrollToPrice = useScrollTo(PRICE_ID);
  const scrollToGeo = useScrollTo(GEO_ID);

  const needBetPositionReload = useSelector(selectNeedBetPositionReload);
  const needBetLeadersReload = useSelector(selectNeedBetLeadersReload);
  const errorCode = useSelector(selectTopBetsErrorCode);

  const dispatch = useDispatch<TDispatch>();

  const handleAddPriceClick = React.useCallback(() => {
    if (isMobile) {
      dispatch(closeAuction());
    }

    scrollToPrice();
  }, [isMobile, dispatch, scrollToPrice]);

  const handleAddGeoClick = React.useCallback(() => {
    if (isMobile) {
      dispatch(closeAuction());
    }

    scrollToGeo();
  }, [isMobile, dispatch, scrollToGeo]);

  const handleReloadClick = React.useCallback(() => {
    dispatch(reloadTopBets());

    /* Если нужно перезагрузить оба запроса ставок и позиций,
       рендерится одна кнопка "Попробовать снова" в блоке "Ставки лидеров" */
    if (needBetPositionReload) {
      dispatch(reloadBetPosition());
    }
  }, [dispatch, needBetPositionReload]);

  if (needBetLeadersReload) {
    return <UnexpectedError onReloadClick={handleReloadClick} />;
  }

  switch (errorCode) {
    case ETopBetsErrorCode.priceAndGeoEmpty:
      return <PriceAndGeoEmptyError onAddButtonClick={handleAddGeoClick} />;

    case ETopBetsErrorCode.priceEmpty:
      return <PriceEmptyError onAddPriceClick={handleAddPriceClick} />;

    case ETopBetsErrorCode.geoEmpty:
      return <GeoEmptyError onAddGeoClick={handleAddGeoClick} />;

    case ETopBetsErrorCode.serviceNotSupported:
      return <ServiceNotSupportedError />;
  }

  return null;
};
